import { StyleSheet, View } from 'react-native';

import { Key } from './Key';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  keyboardRow: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
});

const toUpperCaseIgnoreScharfesS = function (string) {
  if (string === 'ß') {
    return 'ß';
  } else {
    return string.toUpperCase();
  }
};

const keyboard = [
  [
    { letter: 'Q' },
    { letter: 'W' },
    { letter: 'E' },
    { letter: 'R' },
    { letter: 'T' },
    { letter: 'Z' },
    { letter: 'U' },
    { letter: 'I' },
    { letter: 'O' },
    { letter: 'P' },
    { letter: 'Ü' },
  ],
  [
    { letter: 'A' },
    { letter: 'S' },
    { letter: 'D' },
    { letter: 'F' },
    { letter: 'G' },
    { letter: 'H' },
    { letter: 'J' },
    { letter: 'K' },
    { letter: 'L' },
    { letter: 'Ö' },
    { letter: 'Ä' },
  ],
  [
    { letter: 'Y' },
    { letter: 'X' },
    { letter: 'C' },
    { letter: 'V' },
    { letter: 'B' },
    { letter: 'N' },
    { letter: 'M' },
    { letter: 'ß' },
  ],
];

const numbersKeyboard = [
  { letter: '1' },
  { letter: '2' },
  { letter: '3' },
  { letter: '4' },
  { letter: '5' },
  { letter: '6' },
  { letter: '7' },
  { letter: '8' },
  { letter: '9' },
  { letter: '0' },
  { letter: ':' },
];

export function FullKeyboard({
  word,
  onWrong,
  onCorrect,
  currentOrder,
  isWordset,
  isNumberWord,
  capitalizeAll,
  sentence,
  wrongBoxChosen,
}) {
  let specialCaseLetters = [];

  const checkIfThereAreAnySpecialCaseLetters = () => {
    let keyboardLetters = [];
    let letters = [];
    keyboard.map((lettersRow) => {
      lettersRow.map((letter) => {
        keyboardLetters.push(letter.letter.toLowerCase());
      });
    });

    if (isWordset) {
      letters = word.split('');
    } else {
      letters = sentence.split('');
    }

    letters.map((wordLetter) => {
      if (
        !keyboardLetters.includes(wordLetter.toLowerCase()) &&
        wordLetter !== ' '
      ) {
        specialCaseLetters.push({ letter: wordLetter });
      }
    });
  };
  checkIfThereAreAnySpecialCaseLetters();

  if (isNumberWord) {
    return (
      <View style={styles.container}>
        {/* First Row */}
        <View style={styles.keyboardRow}>
          {numbersKeyboard.map((letter, index) => {
            const { letter: letterValue } = letter;
            const isCorrect =
              word.toLowerCase()[currentOrder] == letterValue.toLowerCase();
            const onWrongParam = index;
            return (
              <Key
                wrongBoxChosen={wrongBoxChosen}
                currentOrder={currentOrder}
                onCorrect={onCorrect}
                correct={isCorrect}
                onWrong={onWrong}
                onWrongParam={onWrongParam}
                key={letterValue}
                letter={
                  capitalizeAll
                    ? toUpperCaseIgnoreScharfesS(letterValue)
                    : letterValue.toLowerCase()
                }
              />
            );
          })}
        </View>
      </View>
    );
  } else {
    return (
      <View className="flex-1 justify-center items-center">
        <Row>
          {keyboard[0].map((letter) => {
            const { letter: letterValue } = letter;
            const isCorrect =
              word.toLowerCase()[currentOrder] == letterValue.toLowerCase();
            const onWrongParam = letterValue;
            return (
              <Key
                wrongBoxChosen={wrongBoxChosen}
                currentOrder={currentOrder}
                onCorrect={onCorrect}
                correct={isCorrect}
                onWrong={onWrong}
                onWrongParam={onWrongParam}
                key={letterValue}
                letter={
                  capitalizeAll
                    ? toUpperCaseIgnoreScharfesS(letterValue)
                    : letterValue.toLowerCase()
                }
              />
            );
          })}
        </Row>

        <Row>
          {keyboard[1].map((letter) => {
            const { letter: letterValue } = letter;
            const isCorrect =
              word.toLowerCase()[currentOrder] == letterValue.toLowerCase();
            const onWrongParam = letterValue;

            return (
              <Key
                wrongBoxChosen={wrongBoxChosen}
                currentOrder={currentOrder}
                onCorrect={onCorrect}
                correct={isCorrect}
                onWrong={onWrong}
                onWrongParam={onWrongParam}
                key={letterValue}
                letter={
                  capitalizeAll
                    ? toUpperCaseIgnoreScharfesS(letterValue)
                    : letterValue.toLowerCase()
                }
              />
            );
          })}
        </Row>

        <Row>
          {keyboard[2].map((letter) => {
            const { letter: letterValue } = letter;
            const isCorrect =
              word.toLowerCase()[currentOrder] == letterValue.toLowerCase();
            const onWrongParam = letterValue;
            return (
              <Key
                wrongBoxChosen={wrongBoxChosen}
                currentOrder={currentOrder}
                onCorrect={onCorrect}
                correct={isCorrect}
                onWrong={onWrong}
                onWrongParam={onWrongParam}
                key={letterValue}
                letter={
                  capitalizeAll
                    ? toUpperCaseIgnoreScharfesS(letterValue)
                    : letterValue.toLowerCase()
                }
              />
            );
          })}
          {specialCaseLetters.length > 0 &&
            specialCaseLetters.map((letter) => {
              const { letter: letterValue } = letter;
              const isCorrect =
                word.toLowerCase()[currentOrder] == letterValue.toLowerCase();
              const onWrongParam = letterValue;

              return (
                <Key
                  wrongBoxChosen={wrongBoxChosen}
                  currentOrder={currentOrder}
                  onCorrect={onCorrect}
                  correct={isCorrect}
                  onWrong={onWrong}
                  onWrongParam={onWrongParam}
                  key={letterValue}
                  letter={
                    capitalizeAll
                      ? toUpperCaseIgnoreScharfesS(letterValue)
                      : letterValue.toLowerCase()
                  }
                />
              );
            })}
        </Row>
      </View>
    );
  }
}

const Row = ({ children }) => {
  return (
    <View className="flex-1 flex-row justify-center items-center">
      {children}
    </View>
  );
};
